import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cinema__slides-wrapper single"
};
import { useDeviceStore } from '@remote/store/device';
// import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import CinemaSlideIndex from '@remote/components/cinema/CinemaSlideIndex.vue';
import CinemaSlideMovie from '@remote/components/cinema/CinemaSlideMovie.vue';
import CinemaSlideTVSeries from '@remote/components/cinema/CinemaSlideTVSeries.vue';
import CinemaSlideOther from '@remote/components/cinema/CinemaSlideOther.vue';
import CinemaHeader from '@remote/components/cinema/CinemaHeader.vue';
import 'swiper/swiper.min.css';
import { ref, onMounted, watch, computed } from 'vue';
import { openCinemaTutorial, openDialogScrapeHint, openPopFileSourceAliDrive } from '@remote/utils/dialog';
import { getNFODirs } from '@remote/api/nfo';
import { stat } from '@remote/utils/stat';
import Fail from '@remote/components/Fail.vue';
import { store } from '@remote/store';
import { isAndroidNative } from '@xunlei/universal-native-api';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const deviceStore = useDeviceStore();
    const slides = [{
      id: 'INDEX',
      title: '首页',
      component: CinemaSlideIndex,
      stat: 'home'
    }, {
      id: 'MOVIE',
      title: '电影',
      component: CinemaSlideMovie,
      stat: 'movie'
    }, {
      id: 'TV_SERIES',
      title: '电视剧',
      component: CinemaSlideTVSeries,
      stat: 'tele'
    }, {
      id: 'OTHER',
      title: '其他',
      component: CinemaSlideOther,
      stat: 'other'
    }];
    const currentSlideIndex = ref(0);
    const headerRef = ref(null);
    // const headerVersionWithoutSearch = ref(false)
    const headerVersionWithoutSearch = computed(() => {
      var _deviceStore$currentD;
      return !((_deviceStore$currentD = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD !== void 0 && _deviceStore$currentD.util.hasLabel('withNFOSearch'));
    });
    const isOffline = computed(() => {
      var _deviceStore$currentD2;
      return ((_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.runnerTaskRef.phase) !== 'PHASE_TYPE_RUNNING';
    });
    const target = computed(() => {
      var _store$state$deviceIn;
      return (_store$state$deviceIn = store.state.deviceInfoWatchData) === null || _store$state$deviceIn === void 0 ? void 0 : _store$state$deviceIn.target;
    });
    watch(target, async (val, oldVal) => {
      if (val && oldVal) {
        var _deviceStore$currentN, _deviceStore$currentN2;
        (_deviceStore$currentN = deviceStore.currentNFOInstance) === null || _deviceStore$currentN === void 0 ? void 0 : _deviceStore$currentN.refreshAllList();
        (_deviceStore$currentN2 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN2 === void 0 ? void 0 : _deviceStore$currentN2.refreshPlayRecord();
      }
    });
    const checkDialogScrapeHintShow = async () => {
      var _deviceStore$currentN3, _deviceStore$currentN4;
      const hasInitCinema = (_deviceStore$currentN3 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN3 === void 0 ? void 0 : _deviceStore$currentN3.hasInitCinema;
      const hasInitLocalState = (_deviceStore$currentN4 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN4 === void 0 ? void 0 : _deviceStore$currentN4.hasInitLocalState;
      if (hasInitLocalState && !hasInitCinema) {
        var _deviceStore$currentD3;
        if (!((_deviceStore$currentD3 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD3 !== void 0 && _deviceStore$currentD3.util.isVersionSmallerThan('3.20.0'))) {
          var _deviceStore$currentD4, _deviceStore$currentD5, _deviceStore$currentD6;
          const uid = (_deviceStore$currentD4 = (_deviceStore$currentD5 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD5 === void 0 || (_deviceStore$currentD5 = _deviceStore$currentD5.deviceInfoRef.user) === null || _deviceStore$currentD5 === void 0 ? void 0 : _deviceStore$currentD5.id) !== null && _deviceStore$currentD4 !== void 0 ? _deviceStore$currentD4 : '';
          const canShow = await ((_deviceStore$currentD6 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD6 === void 0 ? void 0 : _deviceStore$currentD6.dialogManager.canDialogShow({
            uid,
            dialogID: 'SCRAPE_HINT'
          }));
          if (canShow) {
            var _deviceStore$currentD7;
            (_deviceStore$currentD7 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD7 === void 0 ? void 0 : _deviceStore$currentD7.dialogManager.dialogShow({
              uid,
              dialogID: 'SCRAPE_HINT'
            });
            openDialogScrapeHint({
              theme: 'dark',
              scene: 'local'
            });
          }
        }
      }
    };
    const unwatch = watch(() => {
      var _deviceStore$currentN5, _deviceStore$currentN6;
      return ((_deviceStore$currentN5 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN5 === void 0 ? void 0 : _deviceStore$currentN5.movieList.length) && ((_deviceStore$currentN6 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN6 === void 0 ? void 0 : _deviceStore$currentN6.tvList.length);
    }, async val => {
      var _deviceStore$currentD8;
      if ((_deviceStore$currentD8 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD8 !== void 0 && _deviceStore$currentD8.util.isVersionSmallerThan('3.9.0')) {
        return;
      }
      if (val) {
        var _store$state$user, _deviceStore$currentD9;
        const userID = (_store$state$user = store.state.user) === null || _store$state$user === void 0 ? void 0 : _store$state$user.userID;
        setTimeout(() => {
          unwatch();
        }, 0);
        const res = await ((_deviceStore$currentD9 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD9 === void 0 ? void 0 : _deviceStore$currentD9.storage.getItem(`${userID}#cinemaTutorial`));
        if (!res) {
          var _deviceStore$currentD10;
          openCinemaTutorial({});
          (_deviceStore$currentD10 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD10 === void 0 ? void 0 : _deviceStore$currentD10.storage.setItem(`${userID}#cinemaTutorial`, 'shown');
        }
      }
    }, {
      immediate: true
    });
    const handleAliDriveAuthCallback = async () => {
      var _deviceStore$currentD11;
      const aliDriveAuthCode = (_deviceStore$currentD11 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD11 === void 0 ? void 0 : _deviceStore$currentD11.fs.aliDriveAuthCode;
      if (aliDriveAuthCode && deviceStore.currentDeviceRef) {
        var _deviceStore$currentD12, _deviceStore$currentD13;
        await ((_deviceStore$currentD12 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD12 === void 0 ? void 0 : _deviceStore$currentD12.fs.getAvailableFSType());
        console.log('即将处理阿里云授权流程', aliDriveAuthCode);
        deviceStore.currentDeviceRef.fs.aliDriveAuthCode = ''; // reset 防重入
        openPopFileSourceAliDrive({
          authCode: aliDriveAuthCode,
          config: {},
          template: (_deviceStore$currentD13 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD13 === void 0 ? void 0 : _deviceStore$currentD13.fs.availableFS.find(i => i.type === 'alidrive')
        });
      }
    };
    onMounted(async () => {
      var _deviceStore$currentD14, _deviceStore$currentN7, _deviceStore$currentN8;
      document.title = '个人片库';
      await deviceStore.untilDeviceReady();
      await ((_deviceStore$currentD14 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD14 === void 0 ? void 0 : _deviceStore$currentD14.untilWatchReady()), (_deviceStore$currentN7 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN7 === void 0 ? void 0 : _deviceStore$currentN7.refreshAllList();
      (_deviceStore$currentN8 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN8 === void 0 ? void 0 : _deviceStore$currentN8.refreshPlayRecord();
      const result = await getNFODirs({
        preset: false
      });
      let hasInit = false;
      if (Array.isArray(result.dirs) && result.dirs.length > 0) {
        hasInit = true;
      }
      stat({
        action: 'cinema_channel_enter',
        data: {
          if_scraper_initial: hasInit ? 1 : 0
        }
      });
      // 处理阿里云认证完成后的回调
      handleAliDriveAuthCallback();
      checkDialogScrapeHintShow();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'cinema__content': true,
          'is-dark': true,
          'without-nfo-search': headerVersionWithoutSearch.value,
          'is-android-sl': _unref(isAndroidNative)
        })
      }, [_createVNode(CinemaHeader, {
        ref_key: "headerRef",
        ref: headerRef,
        slides: slides,
        "header-version-without-search": headerVersionWithoutSearch.value,
        currentSlideIndex: currentSlideIndex.value,
        "onUpdate:currentSlideIndex": _cache[0] || (_cache[0] = $event => currentSlideIndex.value = $event)
      }, null, 8, ["header-version-without-search", "currentSlideIndex"]), isOffline.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Fail)])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "cinema__slides-wrapper",
        style: _normalizeStyle({
          'transform': `translateX(calc(-${currentSlideIndex.value} * 25%))`
        })
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (item, index) => {
        return _createVNode(_resolveDynamicComponent(item.component), {
          key: index,
          "is-showing": currentSlideIndex.value === index
        }, null, 8, ["is-showing"]);
      }), 64))], 4))], 2);
    };
  }
});